@if (config) {
  <div class="highlight">
    <giq-complex-donut-chart
      class="chart"
      [metadata]="info"
    ></giq-complex-donut-chart>
  </div>
}
